import { getReportLogicData } from '@aytm/app/stats/lib/stat-page'

// A rename or delete warns how many reports use the code. Each report's record is read from the page
// model by id, as the sidebar's entries carry it for the open report only.
const countDistinct = (reports, isUsed, getLogicData) =>
  new Set((reports || []).filter(report => (getLogicData(report.id) || []).some(isUsed)).map(report => report.id)).size

const sameName = (a, b) => a.toUpperCase() == b.toUpperCase()

export const countReportsUsingTag = (reports, tag, getLogicData = getReportLogicData) =>
  countDistinct(reports, item => Object.hasOwn(item, 'tag') && sameName(item.tag, tag), getLogicData)

export const countReportsUsingCodebook = (reports, codebook, getLogicData = getReportLogicData) =>
  countDistinct(
    reports,
    item =>
      (Object.hasOwn(item, 'codebook') && sameName(item.codebook, codebook.codebook)) ||
      (Object.hasOwn(item, 'tag') && codebook.tags.some(tag => sameName(item.tag, `${codebook.codebook}: ${tag}`))),
    getLogicData
  )
